import _ from 'lodash';
import React from 'react';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { ThemeProvider } from 'styled-components';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import Loading from '../../../shared/loading';
import { Container, ContentContainer } from '../shared/styles';
import { useGetFunds } from '../../../services/lwadmin/fund/fund-service';
import FundsContext, { reducer, defaultState } from './funds-components/context';
import Actions from './funds-components/actions';
import Fund from './funds-components/fund';
import Header from './funds-components/header';
import ImportModal from './funds-components/import-modal';
import ViewModal from './funds-components/view-modal';
import DataReviewModal from '../fund/form-components/data-review-modal';

const LOAD_FUNDS_ERROR_MESSAGE = (
  'Failed to load funds. The request may have timed out — please refresh the page or try again.'
);

export default function Funds() {
  const [{ data, loading, error }, get] = useGetFunds();
  const [state, dispatch] = React.useReducer(reducer, defaultState);
  const loadingRef = React.useRef();

  useChangeAwareEffect(({ isMount }) => {
    isMount && get();
  }, {});

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  React.useEffect(() => {
    if (error) {
      return;
    }

    const funds = _.get(data, 'funds') || [];

    dispatch({ type: 'setFunds', payload: funds });
  }, [data, error]);

  return (
    <ThemeProvider theme={theme}>
      <FundsContext.Provider value={{ state, dispatch }}>
        <Container>
          <ContentContainer>
            <h1>Funds</h1>
            {!!error && (
              <div className="alert alert-danger" role="alert">
                {LOAD_FUNDS_ERROR_MESSAGE}
              </div>
            )}
            <Header />
            <Loading ref={loadingRef}>
              {state.filteredFunds.map(fund => <Fund key={fund.id} fund={fund} />)}
            </Loading>
            <ImportModal />
            <ViewModal />
          </ContentContainer>
          <Actions />
        </Container>
        <DataReviewModal context={FundsContext} />
      </FundsContext.Provider>
    </ThemeProvider>
  );
}
